
import { defineComponent } from 'vue'
import tableComponent from '@/components/table-component/index.vue'
import { billReApply, BillTimeoutRecordDto, getBillTimeoutList } from '@/api/pay'

export default defineComponent({
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:show', 'success'],
    components: { tableComponent },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            submitting: false,
            tableData: [] as BillTimeoutRecordDto[],
            selectedIds: [] as number[],
            pageInfo: { pageNum: 1, pageSize: 10, total: 0 },
            tableHead: [
                { prop: 'index', reserveSelection: true },
                { prop: 'userName', label: '姓名', width: 150 },
                { prop: 'idCardNo', label: '身份证号', width: 130 },
                { prop: 'payTime', label: '支付时间', width: 150 },
                { prop: 'getSalaryTime', label: '薪资领取时间', width: 150 },
                { prop: 'paymentAmount', label: '金额', width: 90 },
                { prop: 'projectName', label: '项目名称' }
            ]
        }
    },
    watch: {
        show(newValue: boolean) {
            this.dialogVisible = newValue
        },
        dialogVisible(newValue: boolean) {
            this.$emit('update:show', newValue)
        }
    },
    methods: {
        handleOpen() {
            this.selectedIds = []
            this.pageInfo.pageNum = 1
            this.$nextTick(() => ((this.$refs.table as any)?.$refs.elTable as any)?.clearSelection())
            this.getList()
        },
        async getList() {
            this.loading = true
            try {
                const result = await getBillTimeoutList(this.pageInfo)
                this.tableData = result.list || []
                this.pageInfo.total = result.total
            } finally {
                this.loading = false
            }
        },
        handleSelectionChange(rows: BillTimeoutRecordDto[]) {
            this.selectedIds = rows.map(item => item.id)
        },
        handleSizeChange(size: number) { this.pageInfo.pageSize = size; this.pageInfo.pageNum = 1; this.getList() },
        handleCurrentChange(page: number) { this.pageInfo.pageNum = page; this.getList() },
        formatAmount(amount: number) {
            return `￥${Number(amount || 0).toFixed(2)}`
        },
        maskIdCard(idCardNo: string) {
            if (!idCardNo) return '--'
            if (idCardNo.length <= 7) return idCardNo
            return `${idCardNo.slice(0, 3)}******${idCardNo.slice(-4)}`
        },
        getTextLength(text: string) {
            return Array.from(text || '').length
        },
        truncateProjectName(projectName: string) {
            if (!projectName) return '--'
            const characters = Array.from(projectName)
            return characters.length > 10 ? `${characters.slice(0, 10).join('')}...` : projectName
        },
        async handleConfirm() {
            if (!this.selectedIds.length) return
            this.submitting = true
            try {
                await billReApply({
                    ids: this.selectedIds
                })
                this.$message.success('回单申请成功')
                this.dialogVisible = false
                this.$emit('success')
            } finally {
                this.submitting = false
            }
        }
    }
})
